import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import logo from "../Assets/logo.png";
import fmc from "../Assets/fmc.png";
import getForecast from "../mongodb-connect";
import AlertComponent from "./AlertComponent";
import HelpModal from "./HelpModal";

function TopBar({ user, region, setData, action, setShowSignIn, env }) {
  const [showHelpModal, setShowHelpModal] = useState(false);
  const { t } = useTranslation('translation', { keyPrefix: 'topBar' });
  const myStyle = { height: "38px" };
  const website = "https://rapidaim.io";
  
  const userRegions = user
    ? user.signInUserSession.accessToken.payload["cognito:groups"].filter(region => region.includes(region.name))
    : region.subregions;

  const defaultText = region.sponsored ? '--Change region--' : '--Change subregion--';

  const allowedRegions = [{ value: "", text: defaultText}];

  if (userRegions && userRegions.length > 0) {
    userRegions.forEach(subregion => {
      allowedRegions.push({
        value: subregion.startsWith(region.name) ? subregion : `${region.name}-${subregion}`,
        text: `${subregion.replace(`${region.name}-`, '').replace('-', ' ')}`
      })
    });
  }

  const [selected, setSelected] = useState(allowedRegions[0].value);
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setToast] = useState({});

  const buttonOnClick = () => {
    if (user) {
      action();
    }
    else {
      setShowSignIn(true);
    }
  }

  const getRegionSelect = () => {
     return (
      <Col className='mt-1' xs={{order: 3}} lg={{span: 3, order: 2}}>
        <select
          id="regionSelector"
          className="form-control-sm form-select h-100 text-capitalize"
          value={selected}
          onChange={handleChange}
        >
          {allowedRegions.map((option) => (
            <option id={option.value} key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </Col>
    );
  }

  const getButton = () => {
    let buttonProps = {
      onClick: buttonOnClick,
      size: 'xs',
      style: {float: 'right'},
      type: 'button',
      variant: 'secondary'
    };

    let buttonText;
    if (user) {
      buttonText = t('signOut');
      buttonProps.id = 'signOut';
    }
    else {
      buttonText = t('signIn');
      buttonProps.id = 'signIn';
    }

    return (
      <Col lg={{order: 3}} xs={{span: 'auto', order: 2}} className="d-flex align-items-center">
        <Button {...buttonProps}>{buttonText}</Button>
      </Col>
    );
  }

  const getHelpButton = () => {
    let buttonProps = {
      onClick: () => setShowHelpModal(true),
      size: 'xs',
      style: {
        float: 'right',
        padding: '10px 15px',
      },
      type: 'button',
      variant: 'secondary',
      id: 'helpButton'
    };

    let buttonText = t('helpButton');

    return (
        <Col lg={{order: 3}} xs={{span: 'auto', order: 2}} className="d-flex align-items-center">
          <Button {...buttonProps}>{buttonText}</Button>
        </Col>
    );
  }

  const getSponsor = () => {
    return (
      <div className="ml-5">
        <h5 className="text-white mb-0 font-weight-light fs-12">
          {t('sponsoredBy')} <img style={{ height: "26px" }} src={fmc} alt="FMC logo" />
        </h5>
      </div>
    );
  }

  const handleChange = (event) => {
    setSelected(event.target.value);
    if (event.target.value != "") {
      window.dataLayer.push({
        event: 'selectRegion',
        selectedRegion: event.target.value
      });
      getForecast(event.target.value, env)
        .then((response) => {
          setData(response.data);
        })
        .catch(function (error) {
          setShowAlert(true);
          setToast({
            header: error.message,
            body: t('error', {region: allowedRegions.find(option => option.value === event.target.value).text})
          });
        });
    }
  };

  let columnProps;
  if (!region.sponsored) {
    columnProps = {
      xs: true
    }
  }

  return (
    <Container fluid className='bg-primary'>
      <Row className="pt-3 pb-3">
        <Col {...columnProps}>
           <div className="d-flex align-items-center">
             <a href={website}>
               <img style={myStyle} src={logo} alt="RapidAIM logo" />
             </a>
             <div>
               <h3 className="font-weight-bold text-white mb-0 fs-15">
                 {t('title')}
               </h3>
               <h5 className="text-white mb-0 font-weight-light fs-12">
                 {t('poweredBy')} <a className="font-weight-bold" href={website}>{t('company')}</a>
               </h5>
            </div>
            {region.sponsored && getSponsor()}
           </div>
        </Col>
        {region.showHelpButton && getHelpButton()}
        {region.showSignIn && getButton()}
        {region.subregions && getRegionSelect()}
      </Row>
      <AlertComponent header={alert.header} body={alert.body} setShow={setShowAlert} show={showAlert}/>
      <HelpModal show={showHelpModal} handleClose={() => setShowHelpModal(false)} region={region.name}/>
    </Container>
  );
  
}

export default TopBar;
